// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3r2-g","buttons":"Footer_buttons__32O2b"};